import { connect } from 'react-redux';

import { MyAccountOverlayContainer as SourceMyAccountOverlayContainer, mapStateToProps as parentMapStateToProps, mapDispatchToProps  } from 'SourceComponent/MyAccountOverlay/MyAccountOverlay.container';


export { mapDispatchToProps };

/** @namespace Component/MyAccountOverlay/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...parentMapStateToProps(state),
    cmsBlock: state.CmsBlocksAndMenuReducer?.blocks?.items
});

/** @namespace Component/MyAccountOverlay/Container */
export class MyAccountOverlayContainer extends SourceMyAccountOverlayContainer {

    containerProps() {
        const {
            isOverlayVisible,
            isMobile,
            isLoading: propIsLoading,
            onSignIn,
            hideActiveOverlay,
            cmsBlock
        } = this.props;

        const {
            isLoading: stateIsLoading,
            state,
            isCheckout
        } = this.state;

        return {
            isCheckout,
            isLoading: stateIsLoading ? stateIsLoading : propIsLoading,
            isMobile,
            isOverlayVisible,
            onSignIn,
            state,
            hideActiveOverlay,
            cmsBlock
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountOverlayContainer);
